import { GridFilterItem, GridSortModel } from '@mui/x-data-grid-pro';

import { GVOpportunity } from 'models/GoldVision/GVOpportunities';
import { createAsyncAction } from 'typesafe-actions';

export type GetAllGVOpportunitiesRequestPayload = {
  pagination_model: {
    page: number;
    page_size: number;
  };
  sort_model: GridSortModel;
  filter_model: GridFilterItem[];
  search?: string;
};
export type GetAllGVOpportunitiesSuccessPayload = {
  data: {
    totalRowCount: number;
    data: GVOpportunity[];
  };
};

export const getAllGVOpportunities = createAsyncAction(
  'gvOpportunities/getAllGVOpportunities/request',
  'gvOpportunities/getAllGVOpportunities/success',
  'gvOpportunities/getAllGVOpportunities/failure',
)<
  GetAllGVOpportunitiesRequestPayload,
  GetAllGVOpportunitiesSuccessPayload,
  undefined
>();

export type OpportunityKpiFormat = 'integer' | 'percent';

export interface OpportunityKpi {
  key: string;
  label: string;
  value: number;
  format: OpportunityKpiFormat;
  group?: 'team';
  team_id?: number;
}

export interface OpportunityKpisData {
  as_of: string;
  kpis: OpportunityKpi[];
}

export type GetOpportunityKpisSuccessPayload = {
  data: OpportunityKpisData;
};

export const getOpportunityKpis = createAsyncAction(
  'gvOpportunities/getOpportunityKpis/request',
  'gvOpportunities/getOpportunityKpis/success',
  'gvOpportunities/getOpportunityKpis/failure',
)<undefined, GetOpportunityKpisSuccessPayload, undefined>();
